(function () {
	const initProductAccordion = () => {
		$(".product-about__accordion-title").click(function () {
			// Anchor the clicked header in place: when another (often taller)
			// panel above it collapses, the layout above shrinks while the
			// browser keeps the raw scroll offset, which makes the page appear
			// to jump. Keep the clicked header at its current viewport position
			// throughout the open/close animation so it toggles in place.
			const headerEl = this;
			const targetTop = headerEl.getBoundingClientRect().top;
			let anchorFrames = 0;
			const keepInPlace = () => {
				const delta = headerEl.getBoundingClientRect().top - targetTop;
				if (Math.abs(delta) > 0.5) {
					window.scrollBy(0, delta);
				}
				// jQuery slide animations run for ~300ms; compensate across that
				// window plus a couple of trailing frames to settle.
				if (anchorFrames++ < 24) {
					window.requestAnimationFrame(keepInPlace);
				}
			};

			if (!$(this).hasClass("active")) {
				$(".product-about__accordion-title.active").removeClass("active");
				$(this).addClass("active");
				$(".product-about__accordion-content").stop().slideUp(300);
				$(this)
					.siblings(".product-about__accordion-content")
					.eq($(this).index())
					.stop()
					.slideDown(300);
			} else {
				$(this).removeClass("active");
				$(this).siblings(".product-about__accordion-content").stop().slideUp(300);
			}

			window.requestAnimationFrame(keepInPlace);
		});
	};

	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
	});

	initProductAccordion();
})();
